module.exports = __webpack_public_path__ + "img/NY_Bagel_Avocado_Toast.58539954.jpg";